export var supportedContracts = [
    { chainId: 1, address: '0x15C37a9427BAb3c9E82870aF6b8aBEfCCd36751e' },
    { chainId: 10, address: '0x381e9e31C100C28dF22dD91752D08A34B774FdbF' },
    { chainId: 8453, address: '0x5E3189755Df3DBB0FD3FeCa3de168fEEDBA76a79' },
    { chainId: 42161, address: '0xcF0f6c5Fa1A6df8185ED499e10E59ECa6ccb5f33' },
    { chainId: 11155111, address: '0xa8495034DB817013D8C8eF0DBb3d0D595d3a8D4e' },
];
